import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = {
  key: 0,
  class: "col-12 teres-alert bg-lightblue my-3",
  role: "alert"
}
const _hoisted_4 = { class: "row list-unstyled mx-auto mt-2 p-1 p-inline-start-0" }
const _hoisted_5 = { class: "col-12 col-sm-4 col-md-2 px-0 bg-darker rooms-image" }
const _hoisted_6 = { class: "col-12 col-sm-8 col-md-10 d-flex align-items-center" }
const _hoisted_7 = { class: "saal-desc p-2" }
const _hoisted_8 = { class: "room-h2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "ml-auto" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "icon icon-navigation_pfeil_rechts",
    "aria-hidden": "true"
  })
], -1)
const _hoisted_10 = { class: "col-12 d-flex justify-content-end mt-3 px-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_feedback_message = _resolveComponent("feedback-message")!
  const _component_link_shopping_cart = _resolveComponent("link-shopping-cart")!
  const _component_room_image = _resolveComponent("room-image")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_loading_container = _resolveComponent("loading-container")!
  const _component_link_faq = _resolveComponent("link-faq")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('views.roomChooser.title')), 1)
    ]),
    (_ctx.isResetted())
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_feedback_message, {
            message: _ctx.$t('views.roomChooser.resetted')
          }, null, 8, ["message"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_loading_container, { state: _ctx.state }, {
      default: _withCtx(() => [
        _createVNode(_component_link_shopping_cart),
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rooms, (room, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "col-12 mb-3"
            }, [
              _createVNode(_component_router_link, {
                to: '/room/' + room.id,
                class: "d-flex row saal-overview no-underline"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_room_image, { room: room }, null, 8, ["room"])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("h2", _hoisted_8, _toDisplayString(room.name), 1),
                      _createElementVNode("p", null, _toDisplayString(room.description), 1)
                    ]),
                    _hoisted_9
                  ])
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["state"]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_link_faq)
    ])
  ]))
}